
























































import { Component, Vue, Prop } from 'vue-property-decorator';

import { SnsEndpoint, Subscription } from '@/types/core-push';

import tippy from 'tippy.js';

import VueError from '@/components/VueError.vue';
import EnterpriseId from '@/components/EnterpriseId.vue';
import TimestampAgo from '@/components/TimestampAgo.vue';
import HttpEndpointView from '@/components/subscriptions/HttpEndpointView.vue';
import SnsEndpointView from '@/components/subscriptions/SnsEndpointView.vue';
import KinesisEndpointView from '@/components/subscriptions/KinesisEndpointView.vue';
import IotCoreEndpointView from '@/components/subscriptions/IotCoreEndpointView.vue';
import UbidotsEndpointView from '@/components/subscriptions/UbidotsEndpointView.vue';
import SubFilters from '@/components/subscriptions/SubFilters.vue';
import AzureEventHubEndpointView from "@/components/subscriptions/AzureEventHubEndpointView.vue";
import MqttEndpointView from "@/components/subscriptions/MqttEndpointView.vue";


@Component({
  components:{
    VueError,
    EnterpriseId,
    HttpEndpointView,
    SnsEndpointView,
    KinesisEndpointView,
    IotCoreEndpointView,
    UbidotsEndpointView,
    AzureEventHubEndpointView,
    MqttEndpointView,
    SubFilters,
    TimestampAgo
  }
})
export default class SubRow extends Vue {

  @Prop({ default: {},  type: Object}) sub!: Subscription;
  @Prop({ default: 0,  type: Number}) index!: number;

  // internal dependencies
  error:string = '';
  
  async mounted() {
    // nothing here yet
    tippy('[data-tippy-content]');
    
  }

}
